import React, { createRef, Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import DrawerComponent from 'components/DrawerComponent'
import UserPathwaysTable from 'components/admin/UserPathwaysTable'
import { PRACTICE_TYPES } from 'components/admin/UserProgressList/constants'
import {
  Department,
  Name,
  Pathway,
  StyledProgressBarIndicator,
  TotalPracticesDone,
  UserProgressRowWrapper,
} from './component.styles'

const UserProgressRow = ({ practiceType, user }) => {
  const [isOpen, setIsOpen] = useState(false)
  const closeButtonRef = createRef(null)
  const isStudentActivity = practiceType === PRACTICE_TYPES.STUDENT_ACTIVITY

  const toggleUserDrawer = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Fragment key={`user-progress-row-${user.firstName}.${user.lastName}`}>
      <UserProgressRowWrapper onClick={toggleUserDrawer}>
        <Name>{`${user.lastName}, ${user.firstName}`}</Name>
        <Department>{user.department}</Department>
        {user.pathways.map((pathway, index) => {
          const matchingPathway = user.pathways.find(
            ({ pathwayNumber }) => pathwayNumber === index + 1,
          )
          const pathwayKey = `pathway-${matchingPathway?.pathwayNumber}-key`
          const pathwayText = isStudentActivity
            ? matchingPathway?.completed
            : `${matchingPathway?.completed} of ${matchingPathway?.total}`
          return <Pathway key={pathwayKey}>{pathwayText}</Pathway>
        })}
        <TotalPracticesDone>
          {!isStudentActivity && (
            <StyledProgressBarIndicator
              keyText={'practices-complete-progress-bar'}
              percentComplete={Math.floor(
                (user?.totalPracticesComplete / user?.totalPracticesCount) *
                  100,
              )}
              shouldRenderIndicator
              shouldRenderPercentage={false}
            />
          )}
          {isStudentActivity
            ? `${user.totalPracticesComplete}`
            : `${user.totalPracticesComplete}
          of ${user.totalPracticesCount}`}
        </TotalPracticesDone>
      </UserProgressRowWrapper>
      <DrawerComponent
        direction="right"
        handleCloseDrawer={toggleUserDrawer}
        handleScroll={() => {}}
        isOpen={isOpen}
        ref={closeButtonRef}
      >
        {isOpen && (
          <UserPathwaysTable
            firstName={user.firstName}
            lastName={user.lastName}
            practiceType={practiceType}
            rowData={user.rowData}
            totalPracticesComplete={user.totalPracticesComplete}
            totalPracticesCount={user.totalPracticesCount}
          />
        )}
      </DrawerComponent>
    </Fragment>
  )
}

UserProgressRow.propTypes = {
  practiceType: PropTypes.string,
  user: PropTypes.shape({
    department: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    pathways: PropTypes.array,
    programRole: PropTypes.string,
    rowData: PropTypes.array,
    totalPracticesComplete: PropTypes.number.isRequired,
    totalPracticesCount: PropTypes.number.isRequired,
    userId: PropTypes.number,
  }),
}

export default UserProgressRow
